import { trackEvent } from './analytics';
import { captureClientException } from './sentry';

const routeTemplate = (pathname: string): string =>
  pathname
    .split('/')
    .map((part) => (/^\d+$/.test(part) || /^[0-9a-f-]{16,}$/i.test(part) ? ':id' : part))
    .join('/')
    .slice(0, 120);

export const reportClientError = (error: Error, componentStack?: string | null): void => {
  const payload = {
    kind: 'client_error',
    name: error.name.slice(0, 80),
    route: routeTemplate(window.location.pathname),
  };

  trackEvent('client_error', payload);
  captureClientException(error);
  console.error('[CanaBiz]', error.name, componentStack ?? '');
};

export const installGlobalErrorHandlers = (): void => {
  window.addEventListener('error', (event) => {
    reportClientError(event.error instanceof Error ? event.error : new Error('WindowError'));
  });
  window.addEventListener('unhandledrejection', (event) => {
    reportClientError(event.reason instanceof Error ? event.reason : new Error('UnhandledRejection'));
  });
};
